import { missingNativeBuild } from "../nativeError";
import { WidgetUI } from "./view";
var Widgets = Object.freeze({
  write(_data) {
    return Promise.resolve();
  },
  writeView(_view) {
    return Promise.resolve();
  }
});
var LiveActivities = Object.freeze({
  start(_title, _state) {
    var _push = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return Promise.reject(missingNativeBuild("LiveActivities.start"));
  },
  startView(_title, _view) {
    var _push = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return Promise.reject(missingNativeBuild("LiveActivities.startView"));
  },
  update(_id, _state) {
    return Promise.resolve();
  },
  updateView(_id, _view) {
    return Promise.resolve();
  },
  end(_id) {
    return Promise.resolve();
  },
  pushToken(_id) {
    return Promise.resolve(null);
  },
  onPushToken(_listener) {
    return function() {
    };
  }
});
export {
  LiveActivities,
  WidgetUI,
  Widgets
};
//# sourceMappingURL=unavailable.js.map
